import React from 'react';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  loading = false,
  showPageInfo = true,
  className = ""
}) => {
  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && !loading) {
      onPageChange(page);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1 && !loading) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages && !loading) {
      onPageChange(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxVisiblePages = 5;
    const pages = [];
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        if (totalPages > 5) {
          pages.push('...');
          pages.push(totalPages);
        }
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={`card-footer ${className}`}>
      <div className="d-flex justify-content-between align-items-center">
        {showPageInfo && (
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted">
              Page {currentPage} of {totalPages}
            </span>
          </div>
        )}
        
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={handlePreviousPage}
            disabled={currentPage === 1 || loading}
            title="Previous Page"
          >
            <i className="fe fe-chevron-left"></i> Previous
          </button>
            <div className="d-flex gap-1">
            {pageNumbers.map((page, index) => {
              if (page === '...') {
                return (
                  <span key={`ellipsis-${index}`} className="btn btn-sm btn-outline-secondary disabled">
                    ...
                  </span>
                );
              }
              
              return (
                <button
                  key={page}
                  className={`btn btn-sm ${
                    page === currentPage ? 'btn-primary' : 'btn-outline-primary'
                  }`}
                  onClick={() => handlePageChange(page)}
                  disabled={loading}
                  title={`Go to page ${page}`}
                >
                  {page}
                </button>
              );
            })}
          </div>
            <button
            className="btn btn-outline-primary btn-sm"
            onClick={handleNextPage}
            disabled={currentPage === totalPages || loading}
            title="Next Page"
          >
            Next <i className="fe fe-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
